import React from 'react';
import 'translations';
import { datadogRum } from '@datadog/browser-rum';
import { ErrorBoundary } from 'react-error-boundary';

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IntercomProvider } from 'react-use-intercom';

import { PersistGate } from 'redux-persist/integration/react';

import { Provider } from 'react-redux';

import store from './store';

import { Notification } from './components';
import Root from './pages';

import 'services/api.service';
import config from './config';

import ErrorView from 'components/error/error-boundaries';
import { EventProvider, ThemeProvider } from 'providers';

// Config DD RUM
if (config.DD_RUM_TOKEN) {
  datadogRum.init({
    applicationId: config.DD_RUM_ID,
    clientToken: config.DD_RUM_TOKEN,
    site: 'datadoghq.com',
    service: 'railz-dasbhoard',
    env: config.DD_RUM_ENVIRONMENT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

const App: React.FC = () => {
  return (
    <IntercomProvider appId={config.INTERCOM_APP_ID}>
      <ThemeProvider>
        <ErrorBoundary fallback={<ErrorView />}>
          <Provider store={store.getStore()}>
            <PersistGate loading={null} persistor={store.getPersistor()}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <EventProvider>
                  <Notification />
                  <Root />
                </EventProvider>
              </MuiPickersUtilsProvider>
            </PersistGate>
          </Provider>
        </ErrorBoundary>
      </ThemeProvider>
    </IntercomProvider>
  );
};

export default App;
